import { getFeatureFlag } from '@/services/system-feature-service'

const state = {
  flags: {}
}

const mutations = {
  SET_FLAG: (state, { key, enabled }) => {
    state.flags = { ...state.flags, [key]: enabled }
  }
}

const actions = {
  async fetchFlag({ commit }, key) {
    const enabled = await getFeatureFlag(key)
    commit('SET_FLAG', { key, enabled })
    return enabled
  }
}

const getters = {
  isEnabled: (state) => (key) => state.flags[key] || false
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
